import React from "react";
import { Link as RouterLink } from "react-router-dom";
import "./AuthShell.css";

function BrandMark() {
  return (
    <span className="auth-brand-mark" aria-hidden>
      <span />
    </span>
  );
}

export default function AuthShell({
  title,
  subtitle,
  children,
  footer = null,
  maxWidth = 460,
}) {
  return (
    <div className="auth-shell">
      <RouterLink to="/" className="auth-brand">
        <BrandMark />
        <span className="auth-brand-name">Consultto</span>
      </RouterLink>
      <div className="auth-card" style={{ maxWidth }}>
        {(title || subtitle) && (
          <header className="auth-head">
            {title && <h1 className="auth-title">{title}</h1>}
            {subtitle && <p className="auth-subtitle">{subtitle}</p>}
          </header>
        )}
        <div className="auth-body">{children}</div>
      </div>
      {footer && <footer className="auth-foot">{footer}</footer>}
    </div>
  );
}
